import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=330d4d3d&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=330d4d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d4d3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330d4d3d')) {
      api.createRecord('330d4d3d', component.options)
    } else {
      api.reload('330d4d3d', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=330d4d3d&scoped=true&", function () {
      api.rerender('330d4d3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SZV0qQX7VOVf/JS/comp/DocBox.vue"
export default component.exports